import React, {Component, Fragment} from "react";
import {Graphics, Text, withPixiApp} from "@inlet/react-pixi";
import withDesktopSettingPanelConfiguration from "./configuration/withDesktopSettingPanelConfiguration";
import * as PIXI from "pixi.js";
import UIManager from "./../ui/UiBuilder";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Image from 'react-bootstrap/Image'
// import {IStore} from "../../store/IStore";


import {actions as baseGameActions, actions as basegameActions} from "../../reducers/baseGameReducer";
import {actions as freegameActions} from "../../reducers/freeGameReducer";
import withBaseGameConfiguration from "../basegame/configuration/withBaseGameConfiguration";
import {actions as winpresentationAction} from "../../reducers/winPresentationReducer";
import {Container, Button, ButtonToolbar, ButtonGroup, Alert} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import {ParticleUtils} from "pixi-particles";
import {MDBBtn, MDBCol, MDBContainer, MDBIcon, MDBRow, MDBTable, MDBTableBody} from "mdbreact";

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import {isMobile} from "react-device-detect";
import {actions as buttonActions} from "../../reducers/buttonPanelReducer";


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;

}

interface IState {

}

interface IState {
    width: number | string,
    height: number | string,
    pixelRatio: number,
    toggleOn: boolean,
    toggleButtonName: number | string,


}

interface IStateToProps {

}

interface IDispatchToProps {

}

class DesktopSettingPanel extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected DesktopSettingPanelContainer: any;
    protected scope: any;
    protected mainContainerBgColor: any;
    protected textColor: any;
    protected mainOuterBorderColor: any;
    protected borderColorForInsideBoxContainers: any;
    protected bgColorOfInsideBoxContainers: any;
    protected toggleButtonShowIntroScreen: any;
    protected toggleButtonFullScreen: any;
    protected toggleButtonMusic: any;
    protected toggleButtonSpaceBarToSpin: any;
    protected toggleButtonTurboSpin: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.DesktopSettingPanelContainer = React.createRef();
        this.state = {
            width: this.props.width,
            height: this.props.height,
            pixelRatio: 1,
            toggleOn: true,
            toggleButtonName: ""

        }
        this.mainContainerBgColor = 'transparent'
        this.textColor = '#f5f3ec'
        this.mainOuterBorderColor = '#ffffff'
        this.borderColorForInsideBoxContainers = 'transparent'
        this.bgColorOfInsideBoxContainers = 'transparent'
        this.toggleButtonShowIntroScreen = this.props.data.toggleButtonOffImage
        this.toggleButtonFullScreen = this.props.data.toggleButtonOnImage
        this.toggleButtonMusic = this.props.data.toggleButtonOnImage
        this.toggleButtonSpaceBarToSpin = this.props.data.toggleButtonOnImage
        this.toggleButtonTurboSpin = this.props.data.toggleButtonOffImage
    }


    updateDimensions = () => {

        this.setState((prevState) => {
            return {
                ...prevState,
                width: isMobile && window.screen.availWidth || window.innerWidth,
                height: isMobile && window.screen.availHeight || window.innerHeight,
                pixelRatio: window.devicePixelRatio
            }
        })


    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions();

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    onMouseClick = (e: any) => {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return true;
    }


    toggleController = (name: any) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                toggleOn: !this.state.toggleOn,
                toggleButtonName: name
            }
        })
    }


    render() {
        const {
            toggleOn
        } = this.state;
        if (!this.props.showSettingPanelUI) {
            return (
                <></>
            )
        }

        if (toggleOn) {
            if (this.state.toggleButtonName === "firstToggle") {
                this.toggleButtonShowIntroScreen = this.props.data.toggleButtonOffImage
            } else if (this.state.toggleButtonName === "secondToggle") {
                this.toggleButtonFullScreen = this.props.data.toggleButtonOnImage
            } else if (this.state.toggleButtonName === "thirdToggle") {
                this.toggleButtonMusic = this.props.data.toggleButtonOnImage
            } else if (this.state.toggleButtonName === "forthToggle") {
                this.toggleButtonSpaceBarToSpin = this.props.data.toggleButtonOnImage
            } else if (this.state.toggleButtonName === "fifthToggle") {
                this.toggleButtonTurboSpin = this.props.data.toggleButtonOffImage
            }

        } else {
            if (this.state.toggleButtonName === "firstToggle") {
                this.toggleButtonShowIntroScreen = this.props.data.toggleButtonOnImage
            } else if (this.state.toggleButtonName === "secondToggle") {
                this.toggleButtonFullScreen = this.props.data.toggleButtonOffImage
            } else if (this.state.toggleButtonName === "thirdToggle") {
                this.toggleButtonMusic = this.props.data.toggleButtonOffImage
            } else if (this.state.toggleButtonName === "forthToggle") {
                this.toggleButtonSpaceBarToSpin = this.props.data.toggleButtonOffImage
            } else if (this.state.toggleButtonName === "fifthToggle") {
                this.toggleButtonTurboSpin = this.props.data.toggleButtonOnImage
            }
        }

        return (
            <MDBTable style={{
                marginLeft: '0%',
                position: 'absolute',
                top: '0px',
                transform: 'scale(' + this.props.scaleY + ')',
                transformOrigin: 'top'
            }}>
                <MDBTableBody>
                    <tr>
                        <td style={{border: 'none'}}>
                            <MDBContainer style={{pointerEvents: 'auto'}}>
                                <MDBRow style={{border: 'none', height: '70px'}}>
                                    <MDBCol size="12" sm="12"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            position: 'relative', top: '53px',
                                            color: this.textColor, fontSize: '50px', textAlign: 'center',
                                        }}>{this.props.langObj["desktopSettingPanel_Text_1"]}</h2>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                    <MDBCol>
                                        <MDBTable style={{
                                            backgroundColor: this.bgColorOfInsideBoxContainers,
                                            border: 'none'
                                        }}>
                                            <MDBTableBody>
                                                <tr>
                                                    <td colSpan={4}
                                                        style={{border: 'none', position: 'relative', top: '84px'}}>
                                                        <MDBRow>
                                                            <MDBCol sm="6" style={{
                                                                backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                border: 'none',
                                                                height: '61px',
                                                                textAlign: 'right',
                                                                position: 'relative',
                                                                top: '7px',
                                                                right: '26px'
                                                            }}>
                                                                <img src={this.props.data.settingIconImage}/>

                                                            </MDBCol>
                                                            <MDBCol sm="6" style={{
                                                                backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                border: 'none',
                                                                height: '61px',
                                                                textAlign: 'left',
                                                                right: '50px',
                                                                top: '9px'
                                                            }}>
                                                                <h2 style={{
                                                                    // position: 'relative', top: '17%',
                                                                    color: this.textColor, fontSize: '26px',
                                                                }}>{this.props.langObj["desktopSettingPanel_Text_1"]}</h2>
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                            <MDBTableBody style={{border: 'none'}}>
                                                <tr>
                                                    <td style={{
                                                        border: 'none',
                                                        width: '50%',
                                                        position: 'relative',
                                                        top: '114px',
                                                        left: '62px'
                                                    }}>
                                                        <MDBContainer>
                                                            <MDBRow>
                                                                <MDBCol size="7" sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'right'
                                                                }}>
                                                                    <h2 style={{
                                                                        color: this.textColor,
                                                                        fontSize: '20px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_2"]}</h2>
                                                                </MDBCol>

                                                                <MDBCol size='3' sm="5" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'left',
                                                                    position: 'relative',
                                                                    top: '8px'
                                                                }}>
                                                                    <img src={this.toggleButtonShowIntroScreen}
                                                                         className={"firstToggle"}
                                                                         onClick={() => this.toggleController("firstToggle")}
                                                                         style={{cursor: 'pointer'}}/>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                    <td style={{
                                                        border: 'none',
                                                        width: '50%',
                                                        position: 'relative',
                                                        top: '114px',
                                                        left: '62px'
                                                    }}>
                                                        <MDBContainer>
                                                            <MDBRow>
                                                                <MDBCol size="7" sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'right'
                                                                }}>
                                                                    <h2 style={{
                                                                        color: this.textColor,
                                                                        fontSize: '20px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_3"]}</h2>
                                                                </MDBCol>

                                                                <MDBCol size='3' sm="4" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'left',
                                                                    position: 'relative',
                                                                    bottom: '8px'
                                                                }}>
                                                                    <img src={this.toggleButtonFullScreen}
                                                                         className={"secondToggle"}
                                                                         onClick={() => this.toggleController("secondToggle")}
                                                                         style={{cursor: 'pointer'}}/>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>

                                            <MDBTableBody style={{border: "none"}}>
                                                <tr>
                                                    <td style={{border: "none", width: '50%'}}>
                                                        <MDBContainer>
                                                            <MDBRow style={{
                                                                position: 'relative', top: '170px', right: '104px'
                                                            }}>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'end'
                                                                }}>
                                                                    <img src={this.props.data.soundIconImage}/>

                                                                </MDBCol>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'initial',
                                                                    position: 'relative',
                                                                    right: '20px'
                                                                }}>
                                                                    <h2 style={{
                                                                        color: this.textColor,
                                                                        fontSize: '26px',
                                                                        width: '234px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_4"]}</h2>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow style={{
                                                                position: 'relative',
                                                                top: '188px',
                                                                left: '16px'
                                                            }}>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'end',
                                                                    position: 'relative',
                                                                    top: '6px'
                                                                }}>
                                                                    <h2 style={{
                                                                        // position: 'relative', top: '17%',
                                                                        color: this.textColor, fontSize: '20px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_5"]}</h2>
                                                                </MDBCol>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'initial'
                                                                }}>
                                                                    <img src={this.toggleButtonMusic}
                                                                         className={"thirdToggle"}
                                                                         onClick={() => this.toggleController("thirdToggle")}
                                                                         style={{cursor: 'pointer'}}/>

                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                    <td style={{border: "none", width: '50%'}}>
                                                        <MDBContainer>
                                                            <MDBRow style={{
                                                                position: 'relative', top: '170px', right: '50px'
                                                            }}>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'end'
                                                                }}>
                                                                    <img src={this.props.data.autoplayIconImage}/>

                                                                </MDBCol>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'initial',
                                                                    position: 'relative',
                                                                    right: '20px'
                                                                }}>
                                                                    <h2 style={{
                                                                        // position: 'relative', top: '17%',
                                                                        color: this.textColor,
                                                                        fontSize: '26px',
                                                                        width: '234px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_6"]}</h2>
                                                                </MDBCol>
                                                            </MDBRow>

                                                            <MDBRow style={{
                                                                position: 'relative',
                                                                top: '182px',
                                                                right: '22px'
                                                            }}>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    textAlign: 'end',
                                                                    position: 'relative',
                                                                    top: '10px',
                                                                    left: '98px'
                                                                }}>
                                                                    <h2 style={{
                                                                        // position: 'relative', top: '17%',
                                                                        color: this.textColor,
                                                                        fontSize: '20px',
                                                                        width: '218px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_7"]}</h2>
                                                                </MDBCol>
                                                                <MDBCol sm="6" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none'
                                                                }}>
                                                                    <img src={this.toggleButtonSpaceBarToSpin}
                                                                         className={"forthToggle"}
                                                                         onClick={() => this.toggleController("forthToggle")}
                                                                         style={{cursor: 'pointer'}}/>

                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow style={{
                                                                position: 'relative',
                                                                top: '164px',
                                                                right: '66px'
                                                            }}>
                                                                <MDBCol sm="4" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    position: 'relative',
                                                                    left: '172px'
                                                                }}>
                                                                    <img src={this.props.data.turboIconImage}/>
                                                                </MDBCol>
                                                                <MDBCol sm="4" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none',
                                                                    position: 'relative',
                                                                    top: '6px',
                                                                    left: '66px'
                                                                }}>
                                                                    <h2 style={{
                                                                        // position: 'relative', top: '17%',
                                                                        color: this.textColor, fontSize: '20px'
                                                                    }}>{this.props.langObj["desktopSettingPanel_Text_8"]}</h2>
                                                                </MDBCol>
                                                                <MDBCol sm="4" style={{
                                                                    backgroundColor: this.bgColorOfInsideBoxContainers,
                                                                    border: 'none'
                                                                }}>
                                                                    <img src={this.toggleButtonTurboSpin}
                                                                         className={"fifthToggle"}
                                                                         onClick={() => this.toggleController("fifthToggle")}
                                                                         style={{cursor: 'pointer'}}/>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                        </MDBTable>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
            </MDBTable>
        )
    }

}


export default withPixiApp(connect(
    (state: Pick<IStore, 'desktopSettingPanelState' | 'applicationState'>): IStateToProps =>
        ({
            showSettingPanelUI: state.desktopSettingPanelState.showSettingPanel,
            scaleY: state.applicationState.scaleY,
            showFullScreenButton: state.applicationState.showFullScreenButton,

        }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),


    }))(withDesktopSettingPanelConfiguration(DesktopSettingPanel)));